import { Component, inject, Input, OnInit } from '@angular/core';
import { IPricingItem } from '../../../../models/pricing-item.model';
import { ModeratorPricingItemsService } from '../../../../services/moderator-pricing-items.service';
import { EligiblePricingItems } from '../../../../models/eligible-pricing-items.model';
import { BaryFormFactoryService } from '../../../../services/bary-form-factory.service';
import { SearchPricingModel } from '../../../../models/search-pricing.model';
import { SearchPricingFormGroup } from '../../../../models/forms/SearchPricingFormGroup';
import { PricingUnitEnum } from '../../../../models/enums/pricing-unit.enum';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';

@Component({
  selector: 'jhi-pricing-score-search',
  templateUrl: './pricing-score-search.component.html',
})
export class PricingScoreSearchComponent implements OnInit {
  readonly #moderatorPricingItemsService = inject(ModeratorPricingItemsService);
  readonly #baryFormFactoryService = inject(BaryFormFactoryService);

  @Input() offerId!: number | undefined;
  @Input() measureUnit: PricingUnitEnum = PricingUnitEnum.KILOGRAM;

  protected readonly FAS = FaDirectiveEnum.FAS;

  public formGroup: SearchPricingFormGroup = this.#baryFormFactoryService.makeSearchPricingForm();
  public eligiblePricing = new EligiblePricingItems([], [], 0);
  public submit = false;

  private inputFieldLabel = 'LABEL.QUANTITY';

  public ngOnInit() {
    switch (this.measureUnit) {
      case PricingUnitEnum.KILOMETER:
        this.inputFieldLabel = 'PRICING_LIST.SEARCH_BAR.INPUT_FIELD.DISTANCE';
        break;
      case PricingUnitEnum.LDM:
        this.inputFieldLabel = 'PRICING_LIST.SEARCH_BAR.INPUT_FIELD.LDM';
        break;
      default:
        this.inputFieldLabel = 'LABEL.QUANTITY';
        break;
    }
  }

  public searchPricing(): void {
    if (this.canSearch()) {
      const model: SearchPricingModel = new SearchPricingModel(
        this.formGroup.controls.pickupAddress.controls.country.value,
        this.formGroup.controls.pickupAddress.controls.zipCode.value,
        this.formGroup.controls.pickupAddress.controls.cityCode.value,
        this.formGroup.controls.deliveryAddress.controls.country.value,
        this.formGroup.controls.deliveryAddress.controls.zipCode.value,
        this.formGroup.controls.deliveryAddress.controls.cityCode.value,
        this.formGroup.controls.quantity.value,
        this.offerId
      );
      this.#moderatorPricingItemsService.search(model).subscribe(res => {
        this.submit = true;
        if (res.body) {
          this.eligiblePricing = res.body;
        } else {
          this.eligiblePricing = new EligiblePricingItems([], [], 0);
        }
      });
    }
  }

  public canSearch(): boolean {
    return this.formGroup.getAngularForm().valid && this.formGroup.controls.quantity.value > 0;
  }

  public hasResults(): boolean {
    return this.eligiblePricing.pricingItems.length > 0;
  }

  public hasSpecialPlaceResults(): boolean {
    return this.eligiblePricing.specialPlacePricingItems.length > 0;
  }

  public calculateScore(pricingItem: IPricingItem): number {
    if (pricingItem.pickupZipCodeScore && pricingItem.deliveryZipCodeScore) {
      return pricingItem.pickupZipCodeScore + pricingItem.deliveryZipCodeScore;
    }
    return 0;
  }

  public getTransportPrice(pricingItem: IPricingItem): number {
    if (this.eligiblePricing?.transporterDefaultMarginRate > 0) {
      const rateAmount = pricingItem!.price! * (this.eligiblePricing.transporterDefaultMarginRate / 100);
      return rateAmount + pricingItem!.price!;
    } else {
      return pricingItem.price!;
    }
  }
}
